module.exports = __webpack_public_path__ + "img/list-white.720bade4.svg";